<template>
  <x-dialog
    :dialogState="confirmDialogueVar"
    :dialogTitle="dialogTitle"
    :dialogText="dialogText"
    :confirmDialog="true"
    @toggleModal="() => this.$emit('cancelSaveSetting')"
    :actions="{
      show: true,
      secondaryButtonFunction: () => this.$emit('cancelSaveSetting'),
      primaryButtonFunction: saveVirusSetting,
      primaryButtonShow: true,
      secondaryButtonText: cancelText,
      primaryButtonText: successText,
    }"
  ></x-dialog>
</template>
<script>
import PreferenceHelper from '@/helpers/PreferenceHelper';
import PreferencesService from '@/services/PreferencesService';
export default {
  name: 'VirusStateDialog',
  props: [
    'confirmDialogueVar',
    'preferenceText',
    'preferenceId',
    'preferenceKey',
    'checkboxAdmin',
    'checkboxReceiverSender',
    'emails',
    'virusId',
  ],
  data() {
    return {
      dialogTitle: 'Please Confirm',
      dialogText: `Are you sure you want to save Virus ${this.preferenceText} settings ?`,
      cancelText: 'Cancel',
      successText: 'Yes',
      preferenceServiceHelper: null,
    };
  },
  methods: {
    // to update virus settings
    async saveVirusSetting() {
      let reqObject = this.preferenceServiceHelper.createPreferenceBody(
        'virusSetting',
        {
          admin: this.checkboxAdmin,
          senderOrReceiver: this.checkboxReceiverSender,
          emails: this.emails,
        },
        this.preferenceKey
      );
      let url = '';
      if (this.virusId === this.preferenceServiceHelper.defaultPreferenceId) {
        url = PreferencesService.addPreference(this.preferenceId, reqObject);
      } else {
        url = PreferencesService.updatePreference(
          this.preferenceId,
          this.virusId,
          reqObject
        );
      }
      try {
        let res = await url;
        let parsedResponse = this.parseResponse(res);
        this.$emit('setVirusSetting',
          {parsedResponse,
           parsedResponseData: parsedResponse[0],
           action:'saveVirusSetting',
          }
        );
      } catch (err) {
        this.snackbar('error', err);
      }
    },
  },
  mounted() {
    this.preferenceServiceHelper = new PreferenceHelper();
  },
};
</script>